import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_GM_PROJECTS, GET_GM_PROJECTS_SUCCESS, GET_GM_PROJECTS_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getGmProjects({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/gm-dashboard-filters/projects`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_GM_PROJECTS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_GM_PROJECTS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_GM_PROJECTS_ERROR, payload: error });
  }
}

export function* watchGetGmProjects() {
  yield takeEvery(GET_GM_PROJECTS, getGmProjects);
}

function* getGmProjectsSaga() {
  yield all([fork(watchGetGmProjects)]);
}

export default getGmProjectsSaga;